import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "48",
  height: "48",
  rx: "24",
  fill: "#E31E33"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 14.75C14.8619 14.75 14.75 14.8619 14.75 15V21.5C14.75 21.6381 14.8619 21.75 15 21.75H21.5C21.6381 21.75 21.75 21.6381 21.75 21.5V15C21.75 14.8619 21.6381 14.75 21.5 14.75H15ZM13.25 15C13.25 14.0335 14.0335 13.25 15 13.25H21.5C22.4665 13.25 23.25 14.0335 23.25 15V21.5C23.25 22.4665 22.4665 23.25 21.5 23.25H15C14.0335 23.25 13.25 22.4665 13.25 21.5V15ZM26.5 14.75C26.3619 14.75 26.25 14.8619 26.25 15V21.5C26.25 21.6381 26.3619 21.75 26.5 21.75H33C33.1381 21.75 33.25 21.6381 33.25 21.5V15C33.25 14.8619 33.1381 14.75 33 14.75H26.5ZM24.75 15C24.75 14.0335 25.5335 13.25 26.5 13.25H33C33.9665 13.25 34.75 14.0335 34.75 15V21.5C34.75 22.4665 33.9665 23.25 33 23.25H26.5C25.5335 23.25 24.75 22.4665 24.75 21.5V15ZM13.25 26.5C13.25 25.5335 14.0335 24.75 15 24.75H21.5C22.4665 24.75 23.25 25.5335 23.25 26.5V33C23.25 33.9665 22.4665 34.75 21.5 34.75H15C14.0335 34.75 13.25 33.9665 13.25 33V26.5ZM15 26.25C14.8619 26.25 14.75 26.3619 14.75 26.5V33C14.75 33.1381 14.8619 33.25 15 33.25H21.5C21.6381 33.25 21.75 33.1381 21.75 33V26.5C21.75 26.3619 21.6381 26.25 21.5 26.25H15ZM24.75 26.5C24.75 25.5335 25.5335 24.75 26.5 24.75H33C33.9665 24.75 34.75 25.5335 34.75 26.5V33C34.75 33.9665 33.9665 34.75 33 34.75H26.5C25.5335 34.75 24.75 33.9665 24.75 33V26.5ZM26.5 26.25C26.3619 26.25 26.25 26.3619 26.25 26.5V33C26.25 33.1381 26.3619 33.25 26.5 33.25H33C33.1381 33.25 33.25 33.1381 33.25 33V26.5C33.25 26.3619 33.1381 26.25 33 26.25H26.5Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }